import "./src/styles/global.css"
import TagManager from "react-gtm-module"

const tagManagerArgs = {
    gtmId: "GTM-WD8DWK9",
}

TagManager.initialize(tagManagerArgs)
